import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import ServicesSection from '../sections/Services';
import Process from '../sections/Process';

export default function ServicesIndex() {
  return (
    <>
      <SEO
        title="Custom Software Development Services | Farwings Tech Solutions"
        description="We engineer scalable digital platforms, AI automations, and mobile apps for ambitious startups and enterprises."
        keywords="Web Development, AI Automation, SEO Optimization, UI/UX Design, Custom Software"
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Services', path: '/services' },
        ]}
      />
      <PageHero title="Services">
        Web development, mobile apps, SaaS, custom software and AI automation, planned, designed and built by
        one team that stays with you after launch.
      </PageHero>
      <ServicesSection hideHead />
      <Process />
    </>
  );
}
